const HIGH_CHURN_VIEW_PATH_PATTERN = /^\/(?:$|markets(?:\/|$)|sign-up(?:\/|$))/;

/**
 * Data requests and router payloads should not define when a view becomes usable.
 *
 * Markets and home report explicit page-ready timings after their visible data resolves.
 * Across those pages and signup, the automatic Datadog activity window can otherwise
 * stay open for tens of seconds while API polling, RSC prefetches, and navbar route
 * prefetches continue after the first usable paint. Keep static Next.js and image
 * assets tracked; they are omitted from these route-shaped patterns.
 */
export const FIRST_PARTY_BACKGROUND_DATA_URLS = [
    // Exchange, BFF, and other Kalshi API subdomains.
    /^https?:\/\/api(?:[-.][a-z0-9]+)*\.kalshi\.com(?:[/:]|$)/i,
    // Same-origin BFF endpoints (for example /api-app/ai-summary/*).
    /^https?:\/\/(?:www\.)?kalshi\.com\/api(?:[-/]|$)/i,
    /^\/api(?:[-/]|$)/i,
    // Public JSON feeds and banner configuration are display enhancements, not shell readiness.
    // The public-docs hosts also serve market images (see utils/images.ts), so match the feed
    // extension across those hosts rather than excluding the origins wholesale.
    /^https?:\/\/(?:kalshi-public-docs\.s3(?:[.-][a-z0-9-]+)*\.amazonaws\.com|assets\.kalshi\.com)\/[^?#]*\.json(?:\.gz)?(?:[?#]|$)/i,
    /^https?:\/\/giveaway-config\.internal\.kalshi\.com(?:[/:]|$)/i,
];

export const BACKGROUND_ROUTE_ACTIVITY_URLS = [
    // RSC requests and prefetches use the destination page URL rather than /_next/*.
    // Match every page destination while preserving loading-critical chunks and assets.
    /^https?:\/\/(?:www\.)?kalshi\.com\/(?!_next(?:[/?#]|$)|cdn-images(?:[/?#]|$)|images(?:[/?#]|$)|fonts(?:[/?#]|$))(?![^?#]*\.(?:avif|css|gif|ico|jpe?g|js|json|mjs|mp4|png|svg|webm|webmanifest|webp|woff2?)(?:[?#]|$))[^?#]*(?:[?#]|$)/i,
    /^\/(?!_next(?:[/?#]|$)|cdn-images(?:[/?#]|$)|images(?:[/?#]|$)|fonts(?:[/?#]|$))(?![^?#]*\.(?:avif|css|gif|ico|jpe?g|js|json|mjs|mp4|png|svg|webm|webmanifest|webp|woff2?)(?:[?#]|$))[^?#]*\?[^#]*\b_rsc=/i,
];

export const isHighChurnViewPath = (pathname: string): boolean => HIGH_CHURN_VIEW_PATH_PATTERN.test(pathname);

export const isHighChurnViewBackgroundActivity = (
    url: string,
    pathname = typeof window === 'undefined' ? '' : window.location.pathname,
): boolean =>
    isHighChurnViewPath(pathname) &&
    [...FIRST_PARTY_BACKGROUND_DATA_URLS, ...BACKGROUND_ROUTE_ACTIVITY_URLS].some((pattern) => pattern.test(url));
